import { defaultStore } from '@/library/firebase'

export const getAlbum = uid => {
  return new Promise((resolve, reject) => {
    const result = []
    defaultStore
      .collection('reservations')
      .where('uid', '==', uid)
      .where('status', '==', 'uploaded')
      .orderBy('createDate', 'desc')
      .get()
      .then(snap => {
        snap.forEach(doc => {
          if (doc.exists) {
            const data = doc.data()
            result.push(Object.assign(data, { id: doc.id }))
          }
        })
        resolve(result)
      })
      .catch(error => {
        console.log('Error getting document:', error)
        reject(error)
      })
  })
}

export const getAlbumDetail = id => {
  console.log('get album detail: ', id)
  return new Promise((resolve, reject) => {
    defaultStore
      .collection('reservations')
      .doc(id)
      .get()
      .then(doc => {
        if (doc.exists) {
          resolve(Object.assign(doc.data(), { id: doc.id }))
        } else {
          resolve(false)
        }
      })
      .catch(error => {
        console.log('Error getting document:', error)
        reject(error)
      })
  })
}
